<template>

  <div class="breadcrumb m-0">
    <ul>
      <template v-for="(crumb,index) in crumbs" :key="crumb.name">
        <li  :class=" isActive(crumb) ? 'active-crumb' : '' " :data-bs-toggle="hasCanvas(crumb)" :href="getCanvas(crumb)" role="button" aria-controls="offcanvasExample">
          <template v-if="hasUrl(crumb)">
            <router-link :to="{name: crumb.route.url, params: { ...crumb.route.params } }">{{crumb.name}}</router-link>
          </template>
          <template v-else>
            <span :class="( crumb.class ?? '' )"  :style="crumb.style ?? ''">
              {{crumb.name}}
            </span>
          </template>
          &nbsp; {{ index < crumbs.length - 1 ? '/' : '' }} &nbsp;
        </li>
      </template>
    </ul>
  </div>

</template>

<script>
export default {
  name:"BreadCrumb",
  props:['crumbs'],
  computed:{},
  methods:{
    hasCanvas(crumb){
      return this.getCanvas(crumb) && window.innerWidth < 768 ? 'offcanvas' : ''
    },
    getCanvas(crumb){
      return Object.prototype.hasOwnProperty.call(crumb,'offcanvas') ? crumb.offcanvas : '';
    },
    hasUrl(crumb){
      return Object.prototype.hasOwnProperty.call(crumb, 'route');
    },
    isActive(crumb){
      return Object.prototype.hasOwnProperty.call(crumb, 'active');
    }
  }
}

</script>

<style scoped>

</style>